import { TmAuthError } from '@/core/error/transport/auth/TmAuthError'

export class TmAuthEmailIsForbiddenError extends TmAuthError {}
